<template>
  <nav>
    <div class="sticky-wrapper">
      <ul :class="stickyHeaderClass">
        <li class="navtoggle"><a href="#" id="navtoggle">Show Sections</a></li>
        <li :class="{ 'current': isActiveRoute('Overview') }">
          <router-link :to="{name: 'Overview'}">Overview</router-link>
          <ul>
            <li><a href="javascript:;" v-scroll-to="'#intro'">Introduction</a></li>
            <li><a href="javascript:;" v-scroll-to="'#overview'">Overview</a></li>
            <li><a href="javascript:;" v-scroll-to="'#overall-trends'">Overall Trends</a></li>
          </ul>
        </li>
        <li :class="{ 'current': isActiveRoute('States') }">
          <router-link :to="{name: 'States'}">States</router-link>
          <ul>
            <li><a href="javascript:;" v-scroll-to="'#state-overall'">Overall Results</a></li>
            <li><a href="javascript:;" v-scroll-to="'#state-pc-movement'">Percentage Movement</a></li>
            <li><a href="javascript:;" v-scroll-to="'#state-per-capita'">Per Capita Results</a></li>
            <li><a href="javascript:;" v-scroll-to="'#state-results'">Individual State Results</a></li>
          </ul>
        </li>
        <li :class="{ 'current': isActiveRoute('Categories') }">
          <router-link :to="{name: 'Categories'}">Categories</router-link>
          <ul>
            <li><a href="javascript:;" v-scroll-to="'#category-overall'">Highlights</a></li>
            <li><a href="javascript:;" v-scroll-to="'#category-trends'">Trends</a></li>
            <li><a href="javascript:;" v-scroll-to="'#category-pc-movement'">Percentage Movement</a></li>
            <li><a href="javascript:;" v-scroll-to="'#category-results'">Individual Category Results</a></li>
          </ul>
        </li>
        <li :class="{ 'current': isActiveRoute('Appendix') }">
          <router-link :to="{name: 'Appendix'}">Appendix</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
/*eslint-disable */
import * as BaseConstant from '@/utils/BaseConstants.js';

export default {
  name: 'NavMenu',
  data() {
    return {
      stickyHeaderClass: ''
    }
  },
  methods: {
    updateScroll() {
      if (window.scrollY >= 200) {
        this.stickyHeaderClass = 'stuck';
      }
      else {
        this.stickyHeaderClass = '';
      }
    },
    isActiveRoute (routeName = '') {
      let curRouteName = this.$route.name;
      if ( curRouteName=='Category' ) {
        curRouteName = 'Categories'
      }
      return routeName == curRouteName
    },
  },
  created () {
    window.addEventListener('scroll', this.updateScroll);
  }
}
</script>
